import _ from "lodash";
import { useNavigate } from "react-router-dom";
import OrderLabel from "../../modules/OrderLabel";
import constant from "../../resources/constant";

export default function OrderTrackListItem({
  item,
  selected_tab,
  show_completed,
}) {
  const navigate = useNavigate();

  const otp =
    selected_tab === "OUT_FOR_PICKUP"
      ? item?.fulfillment?.pickup?.otp
      : item?.fulfillment?.pickup?.otp;
  const navigate_to =
    constant.ORDER_STATUS[item?.fulfillment?.status]?.id ==
    constant.ORDER_STATUS.CREATED.id
      ? `/search-rider/${item.id}`
      : `/order-detail/${item.id}`;
  const inner_circle_class = !show_completed
    ? _.includes(
        [
          constant.ORDER_STATUS.CREATED.id,
          constant.ORDER_STATUS.OUT_FOR_PICKUP.id,
          constant.ORDER_STATUS.REACHED_PICKUP.id,
        ],
        constant.ORDER_STATUS[item.fulfillment?.status]?.id
      )
      ? "bg-light_pink2"
      : _.includes(
          [
            constant.ORDER_STATUS.PICKED_UP.id,
            constant.ORDER_STATUS.OUT_FOR_DELIVERY.id,
            constant.ORDER_STATUS.IN_TRANSIT.id,
          ],
          constant.ORDER_STATUS[item.fulfillment?.status]?.id
        )
      ? "bg-light_green"
      : _.includes(
          [constant.ORDER_STATUS.UNDELIVERED.id],
          constant.ORDER_STATUS[item.fulfillment?.status]?.id
        )
      ? "bg-[#FFE3CF]"
      : _.includes(
          [constant.ORDER_STATUS.RTO_OUT_FOR_DELIVERY.id],
          constant.ORDER_STATUS[item.fulfillment?.status]?.id
        )
      ? "bg-[#F2C16B]"
      : _.includes(
          [constant.ORDER_STATUS.RTO_UNDELIVERED.id],
          constant.ORDER_STATUS[item.fulfillment?.status]?.id
        )
      ? "bg-[#C4C4C4]"
      : "bg-dark_green"
    : _.includes(
        [constant.ORDER_STATUS.RTO_DELIVERED.id],
        constant.ORDER_STATUS[item.fulfillment?.status]?.id
      )
    ? "bg-[#F2C16B]"
    : _.includes(
        [constant.ORDER_STATUS.CANCELLED.id],
        constant.ORDER_STATUS[item.fulfillment?.status]?.id
          ? constant.ORDER_STATUS[item.fulfillment?.status]?.id
          : 0
      )
    ? "bg-[#BC0000]"
    : "bg-dark_green";
  const upper_circle_class = !show_completed
    ? _.includes(
        [
          constant.ORDER_STATUS.CREATED.id,
          constant.ORDER_STATUS.OUT_FOR_PICKUP.id,
          constant.ORDER_STATUS.REACHED_PICKUP.id,
        ],
        constant.ORDER_STATUS[item.fulfillment?.status]?.id
      )
      ? "bg-pink"
      : _.includes(
          [
            constant.ORDER_STATUS.PICKED_UP.id,
            constant.ORDER_STATUS.OUT_FOR_DELIVERY.id,
            constant.ORDER_STATUS.IN_TRANSIT.id,
          ],
          constant.ORDER_STATUS[item.fulfillment?.status]?.id
        )
      ? "bg-dark_green"
      : _.includes(
          [constant.ORDER_STATUS.UNDELIVERED.id],
          constant.ORDER_STATUS[item.fulfillment?.status]?.id
        )
      ? "bg-[#FFE3CF]"
      : _.includes(
          [constant.ORDER_STATUS.RTO_OUT_FOR_DELIVERY.id],
          constant.ORDER_STATUS[item.fulfillment?.status]?.id
        )
      ? "bg-[#FCF0DB]"
      : _.includes(
          [constant.ORDER_STATUS.RTO_UNDELIVERED.id],
          constant.ORDER_STATUS[item.fulfillment?.status]?.id
        )
      ? "bg-[#C4C4C4]"
      : "bg-dark_green"
    : _.includes(
        [constant.ORDER_STATUS.RTO_DELIVERED.id],
        constant.ORDER_STATUS[item.fulfillment?.status]?.id
      )
    ? "bg-[#F2C16B]"
    : _.includes(
        [constant.ORDER_STATUS.CANCELLED.id],
        constant.ORDER_STATUS[item.fulfillment?.status]?.id
          ? constant.ORDER_STATUS[item.fulfillment?.status]?.id
          : 0
      )
    ? "bg-[#BC0000]"
    : "bg-dark_green";
  const vertical_line_class = !show_completed
    ? _.includes(
        [
          constant.ORDER_STATUS.CREATED.id,
          constant.ORDER_STATUS.OUT_FOR_PICKUP.id,
          constant.ORDER_STATUS.REACHED_PICKUP.id,
        ],
        constant.ORDER_STATUS[item.fulfillment?.status]?.id
      )
      ? "bg-light_pink2"
      : _.includes(
          [
            constant.ORDER_STATUS.PICKED_UP.id,
            constant.ORDER_STATUS.OUT_FOR_DELIVERY.id,
            constant.ORDER_STATUS.REACHED_DELIVERY.id,
            constant.ORDER_STATUS.IN_TRANSIT.id,
          ],
          constant.ORDER_STATUS[item.fulfillment?.status]?.id
        )
      ? "bg-light_green"
      : _.includes(
          [constant.ORDER_STATUS.UNDELIVERED.id],
          constant.ORDER_STATUS[item.fulfillment?.status]?.id
        )
      ? "bg-[#FFE3CF]"
      : _.includes(
          [constant.ORDER_STATUS.RTO_OUT_FOR_DELIVERY.id],
          constant.ORDER_STATUS[item.fulfillment?.status]?.id
        )
      ? "bg-[#FCF0DB]"
      : _.includes(
          [constant.ORDER_STATUS.RTO_UNDELIVERED.id],
          constant.ORDER_STATUS[item.fulfillment?.status]?.id
        )
      ? "bg-[#C4C4C4]"
      : "bg-dark_green"
    : _.includes(
        [constant.ORDER_STATUS.RTO_DELIVERED.id],
        constant.ORDER_STATUS[item.fulfillment?.status]?.id
      )
    ? "bg-[#F2C16B]"
    : _.includes(
        [constant.ORDER_STATUS.CANCELLED.id],
        constant.ORDER_STATUS[item.fulfillment?.status]?.id
          ? constant.ORDER_STATUS[item.fulfillment?.status]?.id
          : 0
      )
    ? "bg-[#FFEAEC]"
    : "bg-dark_green";

  return (
    <div
      className="border-2 border-accents rounded-lg p-4"
      onClick={() => navigate(navigate_to)}
    >
      <div
        className={`flex justify-${
          _.isEmpty(item?.fulfillment?.channel?.order_id) && otp == undefined
            ? "end"
            : "between"
        } items-center mb-1`}
      >
        {!_.isEmpty(item?.fulfillment?.channel?.order_id) && (
          <p className="font-custom text-[10px] font-medium text-gray">
            AWB:{" "}
            <span className="font-bold text-black">
              {item?.fulfillment?.channel?.order_id}
            </span>
          </p>
        )}

        {otp && (
          <p className="font-custom text-[10px] font-medium text-gray">
            OTP: <span className="font-bold text-black">{otp}</span>
          </p>
        )}

        {/* <p className="font-custom text-[10px] font-medium text-gray">
                  Placed At:
                  <span className="font-bold text-black">{`${moment(
                    item.created_at
                  ).format("hh:mmA")}`}</span>
                </p> */}
        {(!_.isEmpty(item?.fulfillment?.channel?.order_id) || otp) && (
          <OrderLabel
            status={
              constant.ORDER_STATUS[item.fulfillment?.status]?.id
                ? constant.ORDER_STATUS[item.fulfillment?.status]?.id
                : 0
            }
          />
        )}
      </div>
      <div className="mt-2">
        <ul className="timeline timeline-vertical w-full">
          <li className="relative flex pb-2">
            <div
              className={`absolute left-1 top-2 h-full w-px ${vertical_line_class}`}
            ></div>
            <div
              className={`absolute top-1 h-2 w-2 rounded-full ${upper_circle_class}`}
            ></div>

            <div className="pl-5 w-full flex justify-between item-baseline">
              <div>
                <p className="line-clamp-1 font-bold text-sm font-custom text-dark_black">
                  {item?.sender_detail?.address?.address_line_1}
                </p>
                <p className="line-clamp-1 text-[10px] text-dark_gray font-custom font-semibold">
                  {item?.sender_detail?.address?.address_line_2}
                </p>
                <p className="text-[10px] text-dark_gray font-custom font-semibold">
                  {item?.sender_detail?.name} <span className="mx-2">|</span>
                  {item?.sender_detail?.mobile}
                </p>
              </div>
              {_.isEmpty(item?.fulfillment?.channel?.order_id) && !otp && (
                <OrderLabel
                  status={
                    constant.ORDER_STATUS[item.fulfillment?.status]?.id
                      ? constant.ORDER_STATUS[item.fulfillment?.status]?.id
                      : 0
                  }
                />
              )}
            </div>
          </li>

          <li className="relative flex">
            <div
              className={`absolute top-1 h-2 w-2 rounded-full ${inner_circle_class}`}
            ></div>

            <div className="pl-5 w-full">
              <div>
                <p className="line-clamp-1 font-bold text-sm font-custom text-dark_black">
                  {item?.customer_detail?.address?.address_line_1}
                </p>
                <p className="line-clamp-1 text-[10px] text-dark_gray font-custom font-semibold">
                  {item?.sender_detail?.address?.address_line_2}
                </p>
                <p className="text-[10px] text-dark_gray font-custom font-semibold">
                  {item?.customer_detail?.name}
                  <span className="mx-2">|</span>
                  {item?.customer_detail?.mobile}
                </p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}
